import type { PublishVersionOption, PublishVersionStatus } from './types';

// 'template' is deliberately absent. A template version is a published gallery
// snapshot, and scene_instance_status can only hold one value, so publishing it to
// an audience would overwrite the status the gallery joins on and delist it.
const PUBLISHABLE_STATUSES: PublishVersionStatus[] = ['draft'];

const NON_PUBLISHABLE_REASON: Partial<Record<PublishVersionStatus, string>> = {
  live: 'Currently published',
  pending: 'Awaiting review',
  archived: 'Archived',
  locked: 'Locked',
  template: 'Live Template',
};

export const VERSION_STATUS_LABEL: Record<PublishVersionStatus, string> = {
  draft: 'Draft',
  live: 'Live',
  archived: 'Archived',
  pending: 'Pending',
  locked: 'Locked',
  template: 'Template',
};

export function makeVersionOption(input: {
  sceneInstanceId: string;
  label: string;
  status: PublishVersionStatus;
  versionNumber?: number;
}): PublishVersionOption {
  const selectable = PUBLISHABLE_STATUSES.includes(input.status);
  return {
    ...input,
    selectable,
    disabledReason: selectable ? undefined : NON_PUBLISHABLE_REASON[input.status],
  };
}
